const LINK_TYPE_LINK = 'link';

const getLinkType = (entity) => entity.linkType ?? LINK_TYPE_LINK;

const isLinkType = (entity) => getLinkType(entity) === LINK_TYPE_LINK;

export const pairLinks = (items) => {
  if (!Array.isArray(items) || items.length === 0) {
    return [];
  }

  const linkPositions = items.reduce((positions, item, index) => {
    if (isLinkType(item)) {
      return [...positions, index];
    }
    return positions;
  }, []);

  const links = items.filter(isLinkType);

  const pairs = links.reduce((pairedLinks, link, index) => {
    const isIndexEven = index % 2 === 0;
    const isLast = index + 1 === links.length;
    if (isIndexEven) {
      pairedLinks.push(isLast ? [link] : [links[index], links[index + 1]]);
    }
    return pairedLinks;
  }, []);

  if (!pairs.length) {
    return items.map((item) => ({ renderType: 'single', item }));
  }

  const singles = items.filter((item) => !isLinkType(item));

  const renderables = [];
  let nextLinkPosition = linkPositions.shift();
  let nextPair = pairs.shift();
  let nextSingle = singles.shift();

  for (let index = 0; index < items.length; index++) {
    if (index === nextLinkPosition && nextPair !== undefined) {
      renderables.push({ renderType: 'pair', items: nextPair });
      nextLinkPosition = linkPositions.shift();
      nextPair = pairs.shift();
    } else if (nextSingle !== undefined) {
      renderables.push({ renderType: 'single', item: nextSingle });
      nextSingle = singles.shift();
    }
  }

  return renderables;
};
